import { fetchWrapper } from '../helpers';

const baseUrl = `${process.env.API_BASE_URL}`;

export const reviewService = {
  getReviews,
  getReviewById,
  publishReview,
  unpublishReview,
  updateReview,
  deleteReview,
};

function getReviews(published) {
  const query = published !== undefined ? `?published=${published}` : '';
  return fetchWrapper.get(`${baseUrl}/reviews${query}`);
}

function getReviewById(id) {
  return fetchWrapper.get(`${baseUrl}/reviews/${id}`);
}

function publishReview(id) {
  return fetchWrapper.put(`${baseUrl}/reviews/${id}/publish`);
}

function unpublishReview(id) {
  return fetchWrapper.put(`${baseUrl}/reviews/${id}/unpublish`);
}

function updateReview(id, values) {
  return fetchWrapper.put(`${baseUrl}/reviews/${id}`, values);
}

function deleteReview(id) {
  return fetchWrapper.delete(`${baseUrl}/reviews/${id}`);
}
